import {defineStore} from "pinia";
import {reactive} from "vue";
import ApontamentoEntidadeEvent from "@/domain/events/apontamentoEntidade.event";
import EmpresaEvents from "@/domain/events/empresa.event";
import UsuarioColaboradorEvents from "@/domain/events/usuarioColaborador.event";
import GrupoPermissaoEvent from "@/domain/events/grupoPermissao.event";
import ClienteEvents from "@/domain/events/cliente.event";
import PlanoSeguroEvents from "@/domain/events/planoSeguro.event";
import SystemEvent from "@/domain/events/system.event";
import SeguroEvents from "@/domain/events/seguro.event";
import LancamentoEvents from "@/domain/events/lancamento.event";
import SinistroEvents from "@/domain/events/sinistro.event";
import VendaEvents from "@/domain/events/venda.event";
import ComissaoEvents from "@/domain/events/comissao.event";
import MetaVendaEvents from "@/domain/events/metaVenda.event";
import MetaVendaColaboradorEvents from "@/domain/events/metaVendaColaborador.event";
import EmpresaDescontoEvents from "@/domain/events/empresaDesconto.event";
import FormaPagamentoTarifaEvents from "@/domain/events/formaPagamentoTarifa.event";
import AutorizacaoEvents from "@/domain/events/autorizacao.event";
import ItemClienteEvents from "@/domain/events/itemCliente.event";

export const useEventsStore = defineStore("eventsStore", () => {


    const usuarioColaboradorEvents = reactive(new UsuarioColaboradorEvents());

    const empresaEvents = reactive(new EmpresaEvents());

    const apontamentoEvents = reactive(new ApontamentoEntidadeEvent());

    const grupoPermissaoEvents = reactive(new GrupoPermissaoEvent());

    const clienteEvents = reactive(new ClienteEvents());
    const itemClienteEvents = reactive(new ItemClienteEvents());

    const planoSeguroEvents = reactive(new PlanoSeguroEvents());

    const systemEvents = reactive(new SystemEvent());

    const seguroEvents = reactive(new SeguroEvents());

    const sinistroEvents = reactive(new SinistroEvents());


    const lancamentoEvents = reactive(new LancamentoEvents());

    const comissaoEvents = reactive(new ComissaoEvents());

    const vendaEvents = reactive(new VendaEvents());

    const metaVendaEvents = reactive(new MetaVendaEvents());
    const metaVendaColaboradorEvents = reactive(new MetaVendaColaboradorEvents());

    const empresaDescontoEvents = reactive(new EmpresaDescontoEvents());

    const formaPagamentoTarifaEvents = reactive(new FormaPagamentoTarifaEvents());

    const autorizacaoEvents = reactive(new AutorizacaoEvents());
    
    const empresaDescontoColaboradorEvents = reactive(new EmpresaDescontoEvents());

    return {
        usuarioColaboradorEvents,
        empresaEvents,
        apontamentoEvents,
        grupoPermissaoEvents,
        clienteEvents,
        itemClienteEvents,
        systemEvents,
        planoSeguroEvents,
        seguroEvents,
        sinistroEvents,
        vendaEvents,
        lancamentoEvents,
        comissaoEvents,
        metaVendaEvents,
        metaVendaColaboradorEvents,
        empresaDescontoEvents,
        formaPagamentoTarifaEvents,
        autorizacaoEvents,
        empresaDescontoColaboradorEvents
    }

})

